// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"b9fb41e40f319a26ee45","147":"89d708ad3d3be8134b02","251":"9a6f14cb4d6bf17fa443","352":"1e70081ed410f38cc6f5","631":"7f6481807ea5020ff807"}[chunkId] + ".js";
};